import { fileUpload, getRequest, postRequest } from './request'
// 商户列表
export function businessLists(params){
  return getRequest("/business/list",
      params
)
}
// 新增商户
export function businessAdd(params){
  return postRequest("/business/add",
      params
)
}
// 配置项编辑
export function businessOptionEdit(params){
  return postRequest("/business/edit/configure",
      params
)
}
// 商户详情
export function businessDetail(params){
  return getRequest("/business/detail",
      params
)
}